import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.accestex.it', // Adjust this to your backend URL
});

// Add a request interceptor to include the token in all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Add a response interceptor to handle token refresh
api.interceptors.response.use(response => {
  return response;
}, async error => {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken) {
      try {
        const { data } = await axios.post(`${import.meta.env.VITE_API_BASE_URL || 'https://api.accestex.it'}/token/refresh`, {}, {
          headers: { 'Authorization': `Bearer ${refreshToken}` }
        });
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        api.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
        originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token;
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Unable to refresh token, redirecting to login");
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/'; // Use window.location to redirect
        return Promise.reject(refreshError);
      }
    } else {
      // No refresh token available, redirect to login
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/'; // Use window.location to redirect
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export default api;
